<template>
  <section class="widget widget-look">
    <h3 class="widget-title">
      Un vistazo a los números por tipo de publicidad
    </h3>
    <card>
      <p>
        Tu publicidad de
        <span class="highlight">branding</span> se relaciona con el
        posicionamiento de tu marca.
      </p>
      <p>
        Tu publicidad
        <span class="highlight">direccional</span> se relaciona con el tráfico a
        tus portales.
      </p>
      <table class="table">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Impresiones</th>
            <th scope="col">Clicks</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td scope="row" class="font-medium">Direccional Total</td>
            <td>{{ Number(direcional.impressions).toLocaleString() }}</td>
            <td>{{ Number(direcional.clicks).toLocaleString() }}</td>
          </tr>
          <tr>
            <td scope="row" class="font-medium">Branding Total</td>
            <td>{{ Number(branding.impressions).toLocaleString() }}</td>
            <td>{{ Number(branding.clicks).toLocaleString() }}</td>
          </tr>
          <tr>
            <td scope="row" class="font-medium">Total</td>
            <td>{{ Number(adsTypeTotal.impressions).toLocaleString() }}</td>
            <td>{{ Number(adsTypeTotal.clicks).toLocaleString() }}</td>
          </tr>
        </tbody>
      </table>
      <h4>Impresiones por tipo de publicidad</h4>
      <apexchart
        type="donut"
        width="300"
        :options="adTypeChartOptions"
        :series="adsTypeSeries"
      />
    </card>
  </section>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "ad-type",
  props: {},
  data() {
    return {
      adTypeChartOptions: {
        labels: ["Branding", "Direccional"],
        colors: ["#FF7B00", "#FFA800"],
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["adsType"]),
    direcional() {
      let res = {
        impressions: (this.adsType.direcionalTotal || {}).impressions || 0,
        clicks: (this.adsType.direcionalTotal || {}).clicks || 0
      };
      return res;
    },
    branding() {
      let impressions = (this.adsType.brandingTotal || {}).impressions || 0;
      let clicks = (this.adsType.brandingTotal || {}).clicks || 0;
      return {
        impressions,
        clicks
      };
    },
    adsTypeTotal() {
      return {
        impressions: this.direcional.impressions + this.branding.impressions,
        clicks: this.direcional.clicks + this.branding.clicks
      };
    },
    adsTypeSeries() {
      return [this.branding.impressions, this.direcional.impressions];
    }
  }
};
</script>
<style lang="scss" scoped></style>
